import { createApi } from "@reduxjs/toolkit/query/react";
import { extendedBaseQuery } from "../basequery";

export const subscriptionApi = createApi({
  reducerPath: "subscriptionApi",
  baseQuery: extendedBaseQuery,
  tagTypes: ["Subscription", "DocumentTopUp"],
  endpoints: (builder) => ({
    getAllUserSubscriptions: builder.query({
      query: (params) => {
        const query = {};
        if (params?.skip) query.skip = params.skip;
        if (params?.limit) query.limit = params.limit;
        if (params?.search) query.search = params.search;
        if (params?.filter) query.filter = params.filter;
        if (params?.sortBy) query.sortBy = params.sortBy;
        if (params?.orderBy) query.orderBy = params.orderBy;
        if (params?.subscriptionType)
          query.subscriptionType = params.subscriptionType;

        return {
          url: `subscription/all-user-subscriptions?${new URLSearchParams(
            query,
          ).toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Subscription"],
    }),
    getAllUserDocumentTopUps: builder.query({
      query: (params) => {
        const query = {};
        if (params?.skip) query.skip = params.skip;
        if (params?.limit) query.limit = params.limit;
        if (params?.search) query.search = params.search;
        if (params?.filter) query.filter = params.filter;
        if (params?.sortBy) query.sortBy = params.sortBy;
        if (params?.orderBy) query.orderBy = params.orderBy;
        if (params?.status) query.status = params.status;

        return {
          url: `subscription/all-user-document-top-ups?${new URLSearchParams(
            query,
          ).toString()}`,
          method: "GET",
        };
      },
      providesTags: ["DocumentTopUp"],
    }),
    bulkSubscriptionOrganization: builder.mutation({
      query: (body) => {
        const formData = new FormData();
        formData.append("file", body.file);
        formData.append("planId", body.planId);
        formData.append("organizationId", body.organizationId);
        if (body.duration) formData.append("duration", body.duration);
        if (body.eventPlace) formData.append("eventPlace", body.eventPlace);
        if (body.tag) formData.append("tag", body.tag);
        if (body.donationDate)
          formData.append("donationDate", body.donationDate);
        return {
          url: "subscription/bulk-subscription-organization",
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ["Subscription"],
    }),
    checkManualSubscriptionUser: builder.mutation({
      query: (body) => ({
        url: "subscription/check-manual-subscription-user",
        method: "POST",
        body,
      }),
    }),
    createManualSubscription: builder.mutation({
      query: (body) => ({
        url: "subscription/manual-subscription",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Subscription"],
    }),
    bulkLinkUserDevice: builder.mutation({
      query: (body) => {
        const formData = new FormData();
        formData.append("file", body.file);
        formData.append("senderOrganizationId", body.senderOrganizationId);
        formData.append(
          "recipientOrganizationId",
          body.recipientOrganizationId,
        );
        if (body.eventPlace) formData.append("eventPlace", body.eventPlace);
        if (body.tag) formData.append("tag", body.tag);
        if (body.duration) formData.append("duration", body.duration);
        return {
          url: "subscription/bulk-link-user-device",
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ["Subscription"],
    }),
    checkBulkDeviceSubscription: builder.mutation({
      query: (body) => {
        const formData = new FormData();
        formData.append("file", body.file);
        formData.append("senderOrganizationId", body.senderOrganizationId);
        formData.append(
          "recipientOrganizationId",
          body.recipientOrganizationId,
        );
        if (body.eventPlace) formData.append("eventPlace", body.eventPlace);
        if (body.tag) formData.append("tag", body.tag);
        return {
          url: "subscription/check-bulk-device-subscription",
          method: "POST",
          body: formData,
        };
      },
    }),
    checkBulkSubscriptionOrganization: builder.mutation({
      query: (body) => {
        const formData = new FormData();
        formData.append("file", body.file);
        return {
          url: "subscription/check-bulk-subscription-organization",
          method: "POST",
          body: formData,
        };
      },
    }),
  }),
});

export const {
  useGetAllUserSubscriptionsQuery,
  useLazyGetAllUserSubscriptionsQuery,
  useGetAllUserDocumentTopUpsQuery,
  useLazyGetAllUserDocumentTopUpsQuery,
  useBulkSubscriptionOrganizationMutation,
  useCheckManualSubscriptionUserMutation,
  useCreateManualSubscriptionMutation,
  useBulkLinkUserDeviceMutation,
  useCheckBulkDeviceSubscriptionMutation,
  useCheckBulkSubscriptionOrganizationMutation,
} = subscriptionApi;
